export default "__VITE_ASSET__CN5eDETz__"